import firebase from 'firebase/app';

export const locScheduleRef = (lid, date) =>
   firebase.firestore().doc(`location/${lid}/schedule/${date}`);
export const locationPeopleIndexRef = (lid) =>
   firebase.firestore().doc(`location/${lid}/indexes/people`);
export const coUsersIndexRef = (cid) =>
   firebase.firestore().doc(`company/${cid}/indexes/people`);
export const coRef = (cid) => firebase.firestore().doc(`company/${cid}`);
